import { useId, useState } from "react";
import { envelopeDeTexto, textoDo, type PerguntaDoFormulario, type ValorDaPergunta } from "../../nucleo/kickoff";

const SUFIXO = ".geovendas.com.br";
const DOMINIO_VALIDO = /^https:\/\/([a-z0-9][a-z0-9-]*)\.geovendas\.com\.br\/?$/i;
const INICIO_VALIDO = /^[a-z0-9][a-z0-9-]*$/;

/** O início do endereço a partir do que foi digitado ou colado; `null` se não der para extrair
 *  sem adivinhar. O endereço completo colado vira só o início; qualquer outro ponto é recusado,
 *  em vez de cortado em silêncio. */
function inicioDoDominio(digitado: string): string | null {
  const texto = digitado.trim().toLowerCase().replace(/^https?:\/\//, "").replace(/\/.*$/, "");
  const inicio = texto.endsWith(SUFIXO) ? texto.slice(0, -SUFIXO.length) : texto;
  return INICIO_VALIDO.test(inicio) ? inicio : null;
}

export function DominioFixoDaInfra({ pergunta, valor, erro, desabilitado, aoMudar }: {
  pergunta: PerguntaDoFormulario;
  valor: ValorDaPergunta | null;
  erro?: string | undefined;
  desabilitado: boolean;
  aoMudar: (valor: ValorDaPergunta | null) => void;
}) {
  const id = useId();
  // O que a pessoa digitou e não dá para gravar fica no campo, com o aviso, até ela corrigir.
  const [recusado, setRecusado] = useState<string | null>(null);
  const salvo = textoDo(valor);
  const inicio = recusado ?? DOMINIO_VALIDO.exec(salvo)?.[1] ?? "";
  const exemplo = DOMINIO_VALIDO.exec(String(pergunta.config.padrao ?? ""))?.[1] ?? "suaempresa";

  return <div className="campo">
    <label className="campo__rotulo" htmlFor={id}>{pergunta.enunciado}{pergunta.obrigatoria ? " *" : ""}</label>
    <div className="dominio-fixo">
      <span aria-hidden="true">https://</span>
      <input id={id} className="campo__controle dominio-fixo__entrada" type="text"
        inputMode="url" autoCapitalize="none" autoComplete="off" spellCheck={false}
        placeholder={exemplo} value={inicio} disabled={desabilitado}
        aria-describedby={`${id}-sufixo${recusado ? ` ${id}-recusado` : ""}${erro ? ` ${id}-erro` : ""}`}
        aria-invalid={Boolean(erro || recusado)}
        onChange={(evento) => {
          const digitado = evento.target.value;
          const novo = inicioDoDominio(digitado);
          setRecusado(novo === null && digitado.trim() ? digitado : null);
          aoMudar(novo ? envelopeDeTexto(`https://${novo}${SUFIXO}`) : null);
        }} />
      <span id={`${id}-sufixo`}>{SUFIXO}</span>
    </div>
    {recusado ? <p className="campo__erro" id={`${id}-recusado`} role="alert">Informe só o início do endereço, com letras, números e hífen. O final {SUFIXO} já está fixo.</p> : null}
    {salvo && !DOMINIO_VALIDO.test(salvo) ? <p className="campo__erro" role="alert">O endereço salvo, <b>{salvo}</b>, não termina em {SUFIXO}. Informe o início para corrigi-lo.</p> : null}
    {erro ? <p className="campo__erro" id={`${id}-erro`} role="alert">{erro}</p> : null}
    {pergunta.ajuda ? <p className="campo__ajuda">{pergunta.ajuda}</p> : null}
  </div>;
}
